import { template as template_4a29abcc0e8e46f4abf2c2daeb5276f1 } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { trackedFunction } from 'reactiveweb/function';
import { and } from 'ember-truth-helpers';
import { findBy } from '@eflexsystems/ember-composable-helpers';
import { t } from 'ember-intl';
import { fn } from '@ember/helper';
const setDeviceOnHardwareModel = (hardware, device)=>{
    Object.assign(hardware, {
        cameraName: device.label,
        cameraId: device.deviceId
    });
};
export default class HardwareWebCam extends Component {
    @service
    webCam;
    availableDevices = trackedFunction(this, async ()=>{
        await this.webCam.load.perform('videoinput');
        return this.webCam.devices.filter((item)=>item.kind === 'videoinput');
    });
    static{
        template_4a29abcc0e8e46f4abf2c2daeb5276f1(`
    <div class="row form-row">
      <div class="col">
        {{#let this.availableDevices as |availableDevices|}}
          {{#if (and @hardware.isNew)}}
            <@form.element
              @controlType="power-select"
              @label={{t "webCam"}}
              @options={{availableDevices.promise}}
              @optionLabelPath="label"
              @value={{findBy "deviceId" @hardware.cameraId availableDevices.value}}
              @onChange={{fn setDeviceOnHardwareModel @hardware}}
            as |el|>
              <el.control @triggerClass="form-control" />
            </@form.element>
          {{else}}
            <@form.element
              @label={{t "webCam"}}
              @value={{@hardware.cameraName}}
            as |el|>
              <el.control readonly class="form-control-plaintext" />
            </@form.element>
          {{/if}}
        {{/let}}
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
